export default __webpack_public_path__ + "static/media/ai-boat-project-pcb.2ba6d2c6.png";